import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AgentProModal from './AgentProModal';
import { modalActions } from '../Store/modalSlice';
import AgentProStartFreeTrialModal from './AgentProStartFreeTrailModal';
import PaymentStatusModal from './PaymentStatusModal';

export default function GlobalModalRenderer() {
  const dispatch = useDispatch();
  const { type, props } = useSelector((state) => state.modal || {});

  if (!type) return null;

  switch (type) {
    case 'agentPro':
      return (
        <AgentProModal
          open
          onClose={() => dispatch(modalActions.closeModal())}
          onPurchase={
            props?.onPurchase || (() => dispatch(modalActions.closeModal()))
          }
        />
      );
    case 'agentProStartFreeTrial':
      return (
        <AgentProStartFreeTrialModal
          open
          onClose={() => dispatch(modalActions.closeModal())}
          onPurchase={
            props?.onPurchase || (() => dispatch(modalActions.closeModal()))
          }
        />
      );
    case 'paymentStatus':
      return (
        <PaymentStatusModal
          open
          status={props?.status}
          title={props?.title}
          subtitle={props?.subtitle}
          items={props?.items}
          backText={props?.backText}
          onBack={props?.onBack}
          onClose={() => dispatch(modalActions.closeModal())}
        />
      );
    default:
      return null;
  }
}
